import React, {useState} from 'react';
import LinkBotton from "../BottomLink";
import FilterBall from "../FilterBall";
import Header from "./Header";
import Body from "./Body";

const ResultDay = (props) => {

    const {items, indexResult} = props;
    const [activeDigit, setActiveDigit] = useState(0);

    return (
        <React.Fragment>
            <div id="main-vn2">
                {/*<div className="clear"/>*/}
                <div className="vn2">
                    <div className="box_kqxs">
                        <Header drawAt={items?.drawAt}/>
                        <div className="content result-day">
                            <Body indexResult={indexResult} items={items}/>
                            <FilterBall activeDigit={activeDigit} setActiveDigit={setActiveDigit}
                                        indexResult={indexResult}/>
                            <div id="DDM1-08-06-2021" className="boxdauduoimien"/>
                        </div>
                        <div className="bottom">
                            <div className="bkl">
                                <div className="bkr">
                                    <div className="bkm"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <LinkBotton/>
                </div>

            </div>
        </React.Fragment>
    )
};

export default (ResultDay);
